import { Card, CardActions, CardContent, TextField, Grid } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import AuthService from "api/Auth";
import styles from "assets/jss/public-styles";
import { SpinnerIndicator } from "components/CallServer";
import MuiRegularButton from "components/MuiExtras/Button/MuiRegularButton";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import { RoutePaths } from "routes/RouteConfig";

////////////////////////////////////////////////////////////////////////////////////////

interface IAuthState {
    submiting: boolean;
}

interface IAuthProps {
}

type Props = IAuthProps & RouteComponentProps<IAuthProps, any, any> & WithStyles<typeof styles> & WithSnackbar & WithTranslation;

////////////////////////////////////////////////////////////////////////////////////////

class ForgotPassword extends React.Component<Props, IAuthState> {
    private authService = new AuthService();
    private authInputRef: HTMLInputElement;

    constructor(props: Props) {
        super(props);
        this.state = {
            submiting: false,
        };
    }

    ///
    private handleSubmit(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        const returnUrl = this.props.location.state ? this.props.location.state.from.pathname : RoutePaths.Login;

        this.setState({ submiting: true });

        this.authService.requestNewPassword(this.authInputRef.value).then((found) => {
            if (found) {
                // Redireciona para a Home ou para o local que solicitou autenticação
                this.props.snackbar.showMessage(this.props.t("Views.Public.ForgotPassword.RequestSuccess"), "success");
                this.props.history.push(returnUrl);
            }
            else {
                this.props.snackbar.showMessage(this.props.t("Views.Public.ForgotPassword.AuthKeyNotFound"), "error");
                this.setState({ submiting: false }, () => this.authInputRef.focus());
            }
        });
    }

    ///
    public render() {
        const { classes } = this.props;
        const { submiting } = this.state;

        return (
            <Card>
                <form autoComplete="on" spellCheck={false}>

                    <CardContent>

                        <TextField
                            label={this.props.t<string>("Views.Public.Login.EmailLabel")}
                            id="email"
                            name="genieId"
                            fullWidth={true}
                            disabled={submiting}
                            autoFocus={true}
                            inputRef={(reference: HTMLInputElement) => { this.authInputRef = reference; }}
                            onChange={() => { this.setState({ submiting: false }); }}
                        />

                    </CardContent>
                    <CardActions className={classes.cardFooter}>
                        <MuiRegularButton
                            size="large"
                            onClick={() => this.props.history.replace(RoutePaths.Login)}
                        >
                            <span>{this.props.t("Common.Buttons.BackText")}</span>
                        </MuiRegularButton>

                        <MuiRegularButton
                            type="submit"
                            color="secondary"
                            size="large"
                            disabled={this.authInputRef == null || this.authInputRef.value.length == 0 || submiting}
                            onClick={(e) => this.handleSubmit(e)}
                        >
                            <span>{this.props.t("Common.Buttons.SubmitText")}&nbsp;</span>
                            {submiting && <SpinnerIndicator />}
                        </MuiRegularButton>

                    </CardActions>
                </form>
            </Card>
        );
    }
}

export default withSnackbar(withTranslation()(withStyles(styles)(ForgotPassword)));